import COM from "./Media";

export default COM;


// WEBPACK FOOTER //
// ./src/js/components/Media/index.js